import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import throttle from 'lodash.throttle';
import { SimpleBackToTop } from '../BackToTop';
import s from './ScrollableContent.scss';
var THROTTLE_TIMEOUT = 200;
var ScrollableContent = /** @class */ (function (_super) {
    tslib_1.__extends(ScrollableContent, _super);
    function ScrollableContent(props) {
        var _this = _super.call(this, props) || this;
        _this.contentRef = React.createRef();
        _this.state = {
            scrolled: false,
        };
        // check if with given content and in a given layout
        // the container is actually scrollable
        _this.notifyIfNotScrollable = function () {
            var contentNode = _this.contentRef.current;
            var onNotScrollable = _this.props.onNotScrollable;
            if (!contentNode) {
                return;
            }
            if (contentNode.clientHeight === contentNode.scrollHeight) {
                onNotScrollable && onNotScrollable();
            }
        };
        _this.handleScroll = throttle(function () {
            var contentNode = _this.contentRef.current;
            if (!contentNode) {
                return;
            }
            var scrollTop = contentNode.scrollTop, scrollHeight = contentNode.scrollHeight, clientHeight = contentNode.clientHeight;
            var distanceToBottom = scrollHeight - scrollTop - clientHeight;
            _this.props.onScrolled &&
                _this.props.onScrolled(scrollTop, distanceToBottom);
            var scrolled = scrollTop > 0;
            if (scrolled !== _this.state.scrolled) {
                _this.setState({ scrolled: scrolled });
            }
        }, _this.throttleTimeout, true);
        // can't use NoLeakyScroll because also need to deal with scroll events
        _this.handleWheel = function (e) {
            var el = _this.contentRef.current;
            if (!el || el.scrollHeight <= el.clientHeight) {
                return;
            }
            if (e.deltaY < 0 && el.scrollTop === 0) {
                e.preventDefault();
            }
            if (e.deltaY > 0 && el.scrollTop === el.scrollHeight - el.clientHeight) {
                e.preventDefault();
            }
        };
        _this.throttleTimeout = props.throttleTimeout || THROTTLE_TIMEOUT;
        return _this;
    }
    ScrollableContent.prototype.componentDidMount = function () {
        if (this.props.onScrolled) {
            this.handleScroll();
            if (this.contentRef.current) {
                this.contentRef.current.addEventListener('scroll', this.handleScroll);
                this.contentRef.current.addEventListener('wheel', this.handleWheel);
            }
        }
        this.notifyIfNotScrollable();
    };
    ScrollableContent.prototype.componentDidUpdate = function () {
        this.notifyIfNotScrollable();
    };
    ScrollableContent.prototype.componentWillUnmountMount = function () {
        if (this.props.onScrolled) {
            if (this.contentRef.current) {
                this.contentRef.current.removeEventListener('scroll', this.handleScroll);
                this.contentRef.current.removeEventListener('wheel', this.handleWheel);
            }
        }
    };
    ScrollableContent.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, wrapperClassName = _a.wrapperClassName, children = _a.children, _b = _a.hasBackToTop, hasBackToTop = _b === void 0 ? false : _b, backToTopClassName = _a.backToTopClassName, backToTopForcedTheme = _a.backToTopForcedTheme;
        return (React.createElement("div", { className: classnames(s['root'], wrapperClassName) },
            React.createElement("div", { className: classnames(s['content'], className), ref: this.contentRef },
                children,
                hasBackToTop && (React.createElement(SimpleBackToTop, { scrolled: this.state.scrolled, getScrollableContainer: function () { return _this.contentRef.current; }, className: backToTopClassName, forcedTheme: backToTopForcedTheme })))));
    };
    return ScrollableContent;
}(React.Component));
export { ScrollableContent };
export default ScrollableContent;
//# sourceMappingURL=ScrollableContent.js.map